
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M392 488H120a48 48 0 01-48-48V72a48 48 0 0148-48h224l96 96v320a48 48 0 01-48 48z","fill":"#cfd2fc"}}),_c('path',{attrs:{"d":"M72 360h368v80a48 48 0 01-48 48H120a48 48 0 01-48-48v-80z","fill":"#5153ff"}}),_c('path',{attrs:{"d":"M440 120h-48a48 48 0 01-48-48V24z","fill":"#8690fa"}}),_c('circle',{attrs:{"cx":"216","cy":"152","fill":"#fff","r":"16"}}),_c('path',{attrs:{"d":"M264 296H152l56-80z","fill":"#5153ff"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M216 384h-16a8 8 0 00-8 8v64a8 8 0 0016 0v-24h8a24 24 0 000-48zm0 32h-8v-16h8a8 8 0 010 16zM168 384a8 8 0 00-8 8v48a8 8 0 01-16 0 8 8 0 00-16 0 24 24 0 0048 0v-48a8 8 0 00-8-8zM296 400a8 8 0 000-16h-32a8 8 0 00-8 8v64a8 8 0 008 8h32a8 8 0 000-16h-24v-16h8a8 8 0 000-16h-8v-16zM376 416h-16a8 8 0 000 16h7.049c-2.252 9.217-8.236 16-15.049 16-8.673 0-16-10.99-16-24s7.327-24 16-24a10.675 10.675 0 014.588 1.058 8 8 0 006.824-14.473A26.587 26.587 0 00352 384c-17.645 0-32 17.944-32 40s14.355 40 32 40 32-17.944 32-40a8 8 0 00-8-8z"}})]),_c('path',{attrs:{"d":"M360 296H216l72-128z","fill":"#8690fa"}})])
          )
        }
      }
    